import { render, staticRenderFns } from "./OnboardingIdPicture.vue?vue&type=template&id=ac3c97e4&"
import script from "./OnboardingIdPicture.vue?vue&type=script&lang=js&"
export * from "./OnboardingIdPicture.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingIdPicture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports